import { useState, useEffect } from "react";
import {
  collection,
  query,
  getDocs,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";

export const useSeriesEpisodes = (seriesId) => {
  const [episodes, setEpisodes] = useState([]);
  const [seriesData, setSeriesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!seriesId) {
      setEpisodes([]);
      setSeriesData(null);
      setLoading(false);
      return;
    }

    let unsubscribe;

    const fetchSeriesAndEpisodes = async () => {
      try {
        // First get the series document using the id field
        const seriesRef = collection(db, "content", "main", "series");
        const seriesQuery = query(seriesRef, where("id", "==", seriesId));
        const seriesSnapshot = await getDocs(seriesQuery);

        if (seriesSnapshot.empty) {
          console.error("No series found with id:", seriesId);
          setError("Series not found");
          setLoading(false);
          return;
        }

        // Get the series data and Firestore document ID
        const firestoreSeriesId = seriesSnapshot.docs[0].id;
        const series = {
          id: firestoreSeriesId,
          ...seriesSnapshot.docs[0].data(),
        };
        setSeriesData(series);

        // Now get episodes using the Firestore document ID
        const episodesRef = collection(
          db,
          "content",
          "main",
          "series",
          firestoreSeriesId,
          "episodes"
        );

        const episodesQuery = query(
          episodesRef,
          orderBy("episodeNumber", "asc")
        );

        unsubscribe = onSnapshot(
          episodesQuery,
          (snapshot) => {
            const episodeData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
              seriesId,
            }));
            setEpisodes(episodeData);
            setLoading(false);
          },
          (err) => {
            console.error("Error fetching episodes:", err);
            setError(err.message);
            setLoading(false);
          }
        );
      } catch (err) {
        console.error("Error setting up series/episodes listener:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchSeriesAndEpisodes();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [seriesId]);

  return { episodes, seriesData, loading, error };
};
